import script from "./ProfuctFilterCate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfuctFilterCate.vue?vue&type=script&setup=true&lang=js"

import "./ProfuctFilterCate.vue?vue&type=style&index=0&id=ac8f1de2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8f1de2"]])

export default __exports__